import { module as BaseModule } from 'modujs'
import gsap from 'gsap'
import ScrollTrigger from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

export default class extends BaseModule {
  init () {
    this.setTimeline()
  }

  setTimeline () {
    gsap.set('.c-footer__leap', { xPercent: 75 })
    gsap.set('.c-footer__flex', { xPercent: 100 })
    gsap.set('.c-footer__b', { xPercent: 50 })
    gsap.set('.c-footer__social', { xPercent: 100 })

    const step1 = gsap
      .timeline({})
      .add(gsap.to('.c-footer__flex', { xPercent: 0, duration: 4 }))

    const step2 = gsap
      .timeline({})
      .add(gsap.to('.c-footer__leap', { xPercent: 0, duration: 2 }))

    const step3 = gsap
      .timeline({})
      .add(gsap.to('.c-footer__b', { xPercent: 0, duration: 2 }))

    const step4 = gsap.timeline({}).add(
      gsap.to('.c-footer__social', {
        xPercent: 0,
        stagger: 0.5,
        duration: 2
      })
    )

    const master = gsap
      .timeline({})
      .add(step1)
      .add(step2, '>-50%')
      .add(step3, '<+25%')
      .add(step4, '<')

    gsap
      .timeline({
        scrollTrigger: {
          trigger: '.c-footer',
          start: 'top-=25% center',
          end: 'bottom bottom',
          scrub: 1,
          id: 'footer'
        }
      })
      .add(master)
  }
}
